export const SMTSideBarData = [
  {
    title: "YOUTUBE LIVE",
    subNav: [
      {
        title: "ADD VIDEO",
        path: "addyoutubelive",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeleteyoutubelive",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "YOUTUBE RECORDED",
    subNav: [
      {
        title: "ADD VIDEO",
        path: "addYoutubeRecordedVideo",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editDeleteYoutubeRecordedVideo",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "PRIME CLASS",
    subNav: [
      {
        title: "ADD VIDEO",
        path: "addFreeVideo",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editFreeVideo",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "YOUTUBE SESSION",
    link: "youtubeSession",
  },
  {
    title: "STORY TYPE",
    subNav: [
      {
        title: "ADD",
        path: "addStoryType",
        cName: "sub-nav",
      },
      {
        title: "EDIT",
        path: "editStoryType",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "EXAM SHORTS VIDEO",
    subNav: [
      {
        title: "ADD",
        path: "addExamSrcVideo",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editExamSrcVideo",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "YOUTUBE SEO TRACKING",
    link: "youtubeSeoTracking",
  },
  {
    title: "QUIZ OF THE DAY",
    subNav: [
      {
        title: "CREATE QUIZ OF THE DAY",
        path: "CreateQuizOfTheDay",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editQuizOfTheDay",
        cName: "sub-nav",
      },
      {
        title: "COPY QUESTIONS TO QUIZ",
        path: "CopyQuestionToQuiz",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "QUIZ CONFIG",
    subNav: [
      {
        title: "ADD",
        path: "addQuizConfig",
        cName: "sub-nav",
      },
      {
        title: "EDIT",
        path: "editQuizConfig",
        cName: "sub-nav",
      },
      {
        title: "QUIZ AVAILABLE QUESTION",
        path: "quizAvailableQuestion",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
];

export const SMTEmpSideBarData = [
  {
    title: "EMPLOYEE DETAILS",
    subNav: [
      {
        title: "Dashboard",
        path: "dashboard",
        cName: "sub-nav",
      },
      {
        title: "My Profile",
        path: "userProfile",
        cName: "sub-nav",
      },
      {
        title: "Policies",
        path: "policy",
        cName: "sub-nav",
      },
      {
        title: "KRA/KPI",
        path: "kraKpi",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "YOUTUBE LIVE",
    subNav: [
      {
        title: "ADD VIDEO",
        path: "addyoutubelive",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editdeleteyoutubelive",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "YOUTUBE RECORDED",
    subNav: [
      {
        title: "ADD VIDEO",
        path: "addYoutubeRecordedVideo",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editDeleteYoutubeRecordedVideo",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "PRIME CLASS",
    subNav: [
      {
        title: "ADD VIDEO",
        path: "addFreeVideo",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editFreeVideo",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "YOUTUBE SESSION",
    link: "youtubeSession",
  },
  {
    title: "STORY TYPE",
    subNav: [
      {
        title: "ADD",
        path: "addStoryType",
        cName: "sub-nav",
      },
      {
        title: "EDIT",
        path: "editStoryType",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "EXAM SHORTS VIDEO",
    subNav: [
      {
        title: "ADD",
        path: "addExamSrcVideo",
        cName: "sub-nav",
      },
      {
        title: "EDIT / DELETE",
        path: "editExamSrcVideo",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "YOUTUBE SEO TRACKING",
    link: "youtubeSeoTracking",
  },
];
